"use client"
import { Box, Menu, MenuItem, SxProps } from "@mui/material"
import { MouseEvent, useState } from "react"
import { TooltipWrapper } from "../Tooltip"
import { Button } from "./Button"

export interface ButtonMenuProps {
  ariaLabel: string
  title: React.ReactNode
  items?: {
    id: string
    description: string
    disabled?: boolean
    tooltipMessage?: string
  }[]
  variant?: "contained" | "outlined" | "text"
  buttonProps?: SxProps
  icon?: React.ReactNode
  endIcon?: React.ReactNode
  onItemSelected: (id: string) => void
  disabled?: boolean
}

export const ButtonMenu = (props: ButtonMenuProps) => {
  const {
    ariaLabel,
    buttonProps,
    icon,
    endIcon,
    items,
    title,
    variant,
    onItemSelected,
    disabled,
  } = props

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuItemClick = (id: string) => {
    setAnchorEl(null)
    onItemSelected(id)
  }

  return (
    <Box>
      <Button
        data-testid="testButtonMenu"
        ariaLabel={ariaLabel}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={icon}
        endIcon={endIcon}
        sx={buttonProps}
        variant={variant}
        onClick={handleClick}
        disabled={disabled}
      >
        {title}
      </Button>
      {items && (
        <Menu
          data-testid="testButtonMenuList"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {items?.map((item) => (
            <TooltipWrapper
              showToolTip={item?.disabled || false}
              message={item?.tooltipMessage}
              key={item.id}
            >
              <MenuItem
                data-testid={`testMenuItem${item.id}`}
                onClick={() => handleMenuItemClick(item.id)}
                disabled={item.disabled}
              >
                {item.description}
              </MenuItem>
            </TooltipWrapper>
          ))}
        </Menu>
      )}
    </Box>
  )
}
